import { classNames } from "../App";
import Datepicker from "react-tailwindcss-datepicker";
import i18n from "../i18n";

export default function CustomDateRangeInput({ className, value, onChange, isSingle = false }) {

    return (
        <Datepicker
            i18n={i18n.language}
            separator="to"
            useRange={false}
            asSingle={isSingle}
            primaryColor="cyan"
            classNames={classNames("", className)}
            value={value}
            popoverDirection="down"
            onChange={onChange} />
    )
}